// extracted by mini-css-extract-plugin
export var container = "_nb-0";